/* eslint-disable no-debugger */
import { createContext, useEffect, useReducer } from 'react';
import { useDispatch, useSelector } from '../store';
import { initialize, authenticate } from '../slices/permission';
import PropTypes from 'prop-types';
import axios from '@lib/axios';
import { API_USER_LOGIN, SYSTEM_INDEX, LOGOUT_URL } from '@utils/FetchUrls';

const AuthContext = createContext({
  platform: 'JWT',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve()
});

export const AuthProvider = (props) => {
  const { children } = props;
  const state = useSelector((state) => state.permission);
  console.log(state);
  const dispatch = useDispatch();
  console.log(AuthContext);
  let fetchSystemIndex = () => {
    return fetch(SYSTEM_INDEX, {
      method: 'POST'
    }).then((res) => {
      return res.json();
    });
  };
  useEffect(() => {
    fetchSystemIndex()
      .then((res) => {
        if (res.code === 401) {
          dispatch(authenticate({ isAuthenticated: false }));
        } else if (res.success) {
          let { backUser: user, menuTree: menu } = res.result;
          dispatch(authenticate({ user, menu, isAuthenticated: true }));
        }
      })
      .finally(() => {
        dispatch(initialize(true));
      });
  }, []);

  const login = async (userName, password) => {
    fetch(API_USER_LOGIN, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userName, password })
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          fetchSystemIndex()
            .then((res) => {
              if (res.code === 401) {
                dispatch(authenticate({ isAuthenticated: false }));
              } else if (res.success) {
                let { backUser: user, menuTree: menu } = res.result;
                dispatch(authenticate({ user, menu, isAuthenticated: true }));
              }
            })
            .finally(() => {
              dispatch(initialize(true));
            });
        }
      })
      .catch((e) => console.log('Oops, error', e));
  };

  const logout = async () => {
    fetch(LOGOUT_URL, {
      method: 'POST'
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          dispatch(authenticate({ isAuthenticated: false }));
        }
      });
  };

  const register = async (email, name, password) => {
    const response = await axios.post('/api/authentication/register', {
      email,
      name,
      password
    });
    dispatch(authenticate(true));
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        platform: 'JWT',
        login,
        logout,
        register
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default AuthContext;
